import { render, staticRenderFns } from "./NeqasSamplesDataTable.vue?vue&type=template&id=6907155a&scoped=true"
import script from "./NeqasSamplesDataTable.vue?vue&type=script&lang=js"
export * from "./NeqasSamplesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6907155a",
  null
  
)

export default component.exports